import { 
  take, 
  put, 
  fork,
  cancel,
  call,
  delay,
  select,
} from 'redux-saga/effects';
import { callApi } from './callApi';
import actionTypes from '../actionTypes';
import { successTournaments, failTournaments, setCasinoTournament } from '../actionCreators/tournaments';
import { getShowTournaments, getSkinId, getCurrentClubId, getCurrentClubPlayerToken} from '../selectors';
import config from "../../config/config";

function* getTournamentCasino() {
  try {
    console.log('getTournamentCasino = ')
    // let showTournaments = yield select(getShowTournaments);
    // while (!showTournaments) {
    //   yield take(actionTypes.TOGGLE_TOURNAMENTS);
    //   showTournaments = yield select(getShowTournaments);
    // }
    const token = yield select(getCurrentClubPlayerToken);
    const skinId = yield select(getCurrentClubId);
    const params = { skinId };
    const headers = token ? { 'x-access-token': token } : {};
    const response = yield call(callApi, `${config.API_TOURNAMENT_URL}/tour/getCasinoTournamentInstances`, 'GET', params, headers);
    console.log('response = ', response);
    
    const { data: tournaments } = response.data.result;
    console.log('tournaments=  ', tournaments);
    yield put(successTournaments(tournaments));
    // yield put(setCasinoTournament(tournaments[0]));
  } catch (e) {
    yield put(failTournaments(e));
  }
}

function* makeTournamentRequests() {
  let request = yield fork(getTournamentCasino);
  while (true) {
    yield delay(config.fetchDataIntervals.tournamentCasinoUpdateInterval);
    if (request) yield cancel(request);
    request = yield fork(getTournamentCasino);
  }
}

export function* watchRequestToursOnAuthentication() {
  if (typeof window === 'undefined') return;
  let requestTask = yield fork(makeTournamentRequests);
  const token = yield select(getCurrentClubPlayerToken);
  if (token) {
    yield take(actionTypes.USER_LOGOUT);
    if (requestTask) yield cancel(requestTask);
    requestTask = yield fork(makeTournamentRequests);
  }

  while (true) {
    yield take(actionTypes.LOGIN_SUCCESS);
    if (requestTask) yield cancel(requestTask);
    requestTask = yield fork(makeTournamentRequests);
    yield take(actionTypes.USER_LOGOUT);
    if (requestTask) yield cancel(requestTask);
  }
}

export function* watchRequestTournaments() {
  while (true) {
    yield take(actionTypes.TOURNAMENTS_REQUEST);
    yield fork(getTournamentCasino);
  }
}